import dompurify from "dompurify";

export const statesList = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];


export const sanitizeInput = (input) => {
  return dompurify.sanitize(input);
};


let allowedExtensionsRegex = /\.(pdf|doc|docx|xls|xlsx|csv)$/i;

let allowedMimeTypes = [
  "application/pdf",
  "application/msword", // DOC
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
  "application/vnd.ms-excel", // XLS
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
  "text/csv",
];

export const checkFileTypesAndSize = (fileName, fileType, fileSize, maxSize) => {
  const isValidExtension = allowedExtensionsRegex.test(fileName);
  const isValidMimeType = allowedMimeTypes.includes(fileType);
  const isFileSizeValid = fileSize <= maxSize;

  if (!isValidExtension || !isValidMimeType) {
    return { isValid: false, error: "Invalid file type/extension; Only PDF, DOC and Excel files (xlsx, xls, doc, docx, pdf, csv) can be uploaded." };
  } else if (!isFileSizeValid) {
    return { isValid: false, error: `File "${fileName}" exceeds the maximum file size of ${maxSize / 1024 / 1024}MB.` };
  }

  return { isValid: true };
};

